import React from "react";
import { ShieldCheck, CreditCard } from "lucide-react";
import { useLang } from "@/App";

const ICONS = [ShieldCheck, CreditCard];

export default function Benefits() {
  const { t } = useLang();
  const b = t.benefits;
  return (
    <section className="py-16 md:py-20 bg-slate-50" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">{b.kicker}</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-blue-950 leading-tight">
            {b.title}
          </h2>
        </div>
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {b.items.map((item, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <article
                key={i}
                className="relative overflow-hidden rounded-3xl bg-white border border-slate-200 p-7 md:p-8 hover:shadow-xl transition-shadow"
                data-testid={`benefit-${i}`}
              >
                <div className="absolute -right-4 -top-4 text-7xl md:text-8xl font-extrabold text-sky-50 select-none pointer-events-none">
                  {item.highlight}
                </div>
                <div className="relative">
                  <div className="grid place-items-center w-14 h-14 rounded-2xl bg-blue-900 text-white">
                    <Icon className="w-7 h-7" />
                  </div>
                  <h3 className="mt-5 text-2xl md:text-3xl font-extrabold text-blue-950 leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base md:text-lg text-slate-700 leading-relaxed max-w-md">
                    {item.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
